<template>
    <div class="add-column-form">
        <div class="form">
            <div class="field">
                <label class="label">{{ $t("wp.columnType") }}</label>
                <a-select :value="columnType" @change="handleColumnTypeChange">
                    <a-select-option v-for="col in getAllowedColumns()" :value="col.id" :key="col.id">
                        {{ col.title }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="field" v-if="columnType === 'custom'">
                <label class="label">{{ $t("wp.columnName") }}</label>
                <a-input ref="userNameInput" v-model="columnName" :placeholder="$t('whatsapp.typeColumnName')" :required="true">
                    <a-tooltip slot="suffix" :title="$t('whatsapp.columnNameInfo')">
                        <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
                    </a-tooltip>
                </a-input>
            </div>
            <div class="field">
                <label class="label">{{ $t("wp.defaultValue") }}</label>
                <a-input ref="userNameInput" v-model="defaultValue" :placeholder="$t('wp.defaultValue')">
                    <a-tooltip slot="suffix" :title="$t('wp.setDefaultValue')">
                        <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
                    </a-tooltip>
                </a-input>
            </div>

            <a-divider />
            <div class="buttons">
                <a-button @click="cancel">{{ $t("wp.cancel") }}</a-button>
                <a-button type="primary" @click="save" :disabled="!isValid()"> {{ $t("wp.save") }}</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../utils/log2";
import _ from "lodash";

const log = log2("AddColumnForm");
export default {
    name: "AddColumnForm",
    props: {
        onCompleted: {
            type: Function,
            required: true,
        },
        onCancelled: {
            type: Function,
            required: true,
        },
        hiddenColumns: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data() {
        return {
            columnType: "",
            columnName: "",
            defaultValue: "",
        };
    },
    methods: {
        isValid() {
            return true;
        },
        getAllowedColumns() {
            const preDefinedCols = [
                { id: "name", title: this.$t("wp.name") },
                { id: "age", title: this.$t("wp.age") },
                { id: "location", title: this.$t("wp.location") },
                { id: "tag", title: this.$t("whatsapp.tag") },
                { id: "website", title: this.$t("whatsapp.website") },
                { id: "Gender", title: this.$t("wp.gender") },
                { id: "custom", title: this.$t("whatsapp.custom") },
            ];

            return preDefinedCols.filter((col) => !this.hiddenColumns.includes(col.id));
        },
        handleColumnTypeChange(val) {
            log("handleColumnTypeChange", val);
            const found = this.getAllowedColumns().find((col) => col.id === val);
            if (found) {
                this.columnType = found.id;
                if (val === "custom") {
                    this.columnName = "";
                } else {
                    this.columnName = found.id;
                }
            }
        },
        cancel() {
            this.onCancelled();
            this.columnName = "";
            this.defaultValue = "";
            this.columnType = "";
        },
        save() {
            if (_.isEmpty(this.columnName)) {
                this.$message.error("Column name is required");
                return;
            }
            this.onCompleted(this.columnName.toString().toLowerCase().trim(), this.defaultValue);
            this.columnName = "";
            this.defaultValue = "";
            this.columnType = "";
        },
    },
    mounted() {
        this.columnType = _.get(this.getAllowedColumns(), "0.id", "");
        this.columnName = _.get(this.getAllowedColumns(), "0.title", "");
    },
};
</script>

<style lang="scss">
.add-column-form {
    width: 300px;
    padding: 16px;

    .form {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .field {
            display: flex;
            flex-direction: column;
            gap: 4px;

            .label {
                font-size: 12px;
                color: #333;
                font-weight: 500;
            }

            .ant-select {
                width: 100%;
            }

            .ant-input {
                width: 100%;
            }
        }

        .ant-divider {
            margin: 4px 0;
        }

        .buttons {
            display: flex;
            justify-content: flex-end;
            gap: 8px;
        }
    }
}
</style>
